<template>
  <div class="comment__audit-compare-content comment__item-definition-content">
    <template v-if="isChanged">
      <BasicCheckbox
        v-if="beforeDefinitionName"
        :modelValue="beforeDefinitionStatus"
        :label="beforeDefinitionName"
        :isDisabled="true"
        checkType="check"
      />
      <icon
        v-if="beforeDefinitionName && afterDefinitionName"
        data="@icon/arrow-to.svg"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
        color="var(--monochrome05to04)"
      />
      <BasicCheckbox
        v-if="afterDefinitionName"
        :modelValue="afterDefinitionStatus"
        :label="afterDefinitionName"
        :isDisabled="true"
        checkType="check"
        class="comment__item-definition-checkbox"
      />
    </template>
    <BasicCheckbox
      v-else
      :modelValue="afterDefinitionStatus"
      :label="afterDefinitionName"
      :isDisabled="true"
      checkType="check"
      class="comment__item-definition-checkbox"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import BasicCheckbox from "@/components/Form/BasicCheckbox.vue"

import { Comment } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const beforeDefinitionName = computed(() => props.comment.before?.definitionOfDoneName ?? "")
const beforeDefinitionStatus = computed(() => props.comment.before?.definitionOfDoneState ?? false)
const afterDefinitionStatus = computed(() => props.comment.after?.definitionOfDoneState ?? false)
const afterDefinitionName = computed(() => props.comment.after?.definitionOfDoneName ?? "")
const isChanged = computed(() => Boolean(beforeDefinitionName.value))
</script>
